import { Block, ValidatedInputOutputBlock } from '~/protos/agents'
import store from '~/store'
import { upsertBlock } from '../slice'
import { AbsReactiveBlock } from './AbsReactiveBlock'

export class ReactiveInputOutputBlock extends AbsReactiveBlock {
  constructor(block: ValidatedInputOutputBlock) {
    super()
    this.onSampleInputChange = this.onSampleInputChange.bind(this)
    this.onSampleOutputChange = this.onSampleOutputChange.bind(this)
    this._block = Block.fromPartial({
      validatedInputOutputBlock: block
    })
  }

  public onSampleInputChange(input: string) {
    if (this._block.validatedInputOutputBlock) {
      this._block = Block.fromPartial({
        validatedInputOutputBlock: ValidatedInputOutputBlock.fromPartial({
          ...this._block.validatedInputOutputBlock,
          inputExample: input
        })
      })
      store.dispatch(upsertBlock({ id: this.id, block: this._block }))
    }
  }

  public onSampleOutputChange(output: string) {
    if (this._block.validatedInputOutputBlock) {
      this._block = Block.fromPartial({
        validatedInputOutputBlock: ValidatedInputOutputBlock.fromPartial({
          ...this._block.validatedInputOutputBlock,
          outputExample: output
        })
      })
      store.dispatch(upsertBlock({ id: this.id, block: this._block }))
    }
  }
}
